import s from './Footer.module.css';
import map from './../../img/footer/map.svg';
import mail from './../../img/footer/mail.svg';
import phone from './../../img/footer/phone.svg';
import {Link} from "react-router-dom";

const Footer = () => {
    return (
        <div className={s.footer}>
            <div className={s.footer__item}>
                <h3>ИНФОРМАЦИЯ</h3>
                <ul>
                    <li><Link to="info">О нас</Link></li>
                    <li><Link to="delivery">Доставка</Link></li>
                    <li><Link to="security">Политика безопасности</Link></li>
                    <li>Как заказать?</li>
                </ul>
            </div>
            <div className={s.footer__item}>
                <h3>ДОПОЛНИТЕЛЬНО</h3>
                <ul>
                    <li><Link to="brands">Производители</Link></li>
                    <li>Подарочные сертификаты</li>
                    <li>Партнерская программа</li>
                    <li>Акции</li>
                    <li><Link to="contacts">Связаться с нами</Link></li>
                    <li>Возврат товара</li>
                    <li>Карта сайта</li>
                </ul>
            </div>
            <div className={s.footer__item}>
                <h3>ЛИЧНЫЙ КАБИНЕТ</h3>
                <ul>
                    <li><Link to="account">Личный Кабинет</Link></li>
                    <li><Link to="account/orders">История заказов</Link></li>
                    <li><Link to="account/liked">Закладки</Link></li>
                    <li>Рассылка</li>
                </ul>
            </div>
            <div className={s.footer__item}>
                <h3>КОНТАКТЫ</h3>
                <ul>
                    <li><img src={map} alt=""/>
                        Украина
                    </li>
                    <li><img src={phone} alt=""/>
                        38011111111
                    </li>
                    <li><img src={mail} alt=""/>
                        example@gmail.com
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default Footer;